import type { TimeLeftType } from '../types'

export const formatTime = (timeLeft: TimeLeftType): string => {
  const { hours, minutes, seconds } = timeLeft
  const formattedMinutes = String(minutes).padStart(2, '0')
  const formattedSeconds = String(seconds).padStart(2, '0')
  return hours > 0
    ? `${hours}:${formattedMinutes}:${formattedSeconds}`
    : `${minutes}:${formattedSeconds}`
}
